import { render, staticRenderFns } from "./DriversPeriodAvailableEditForm.vue?vue&type=template&id=b1ca6bc4&scoped=true&"
import script from "./DriversPeriodAvailableEditForm.vue?vue&type=script&lang=js&"
export * from "./DriversPeriodAvailableEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DriversPeriodAvailableEditForm.vue?vue&type=style&index=0&id=b1ca6bc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ca6bc4",
  null
  
)

export default component.exports